import React, { useEffect, useState } from "react";
import $ from "jquery"; // Import jQuery
import "jquery-ui/ui/widgets/draggable"; // Import draggable from jQuery UI

function Homepage() {

    const vsCodeIcon = (
        <svg className="code-editor-icon animate__animated animate__headShake" width="80px" height="80px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.707 9.707A.996.996 0 003 9V5a1 1 0 011-1 1 1 0 000-2C2.346 2 1 3.346 1 5v3.586l-.707.707a.999.999 0 000 1.414l.707.707V15c0 1.654 1.346 3 3 3a1 1 0 000-2 1 1 0 01-1-1v-4a.996.996 0 00-.293-.707L2.414 10l.293-.293zm17.217-.09a1.001 1.001 0 00-.217-.324L19 8.586V5c0-1.654-1.346-3-3-3a1 1 0 100 2 1 1 0 011 1v4a.997.997 0 00.293.707l.293.293-.293.293A.996.996 0 0017 11v4a1 1 0 01-1 1 1 1 0 100 2c1.654 0 3-1.346 3-3v-3.586l.707-.707a1.001 1.001 0 00.217-1.09zm-7.227-4.333a1.002 1.002 0 00-1.63.346l-3.996 8a.999.999 0 00.56 1.299 1.006 1.006 0 001.302-.557l3.995-8a.997.997 0 00-.23-1.088z" fill="black" /></svg>
    );

    const minimizedIconStyle = {
        position: "absolute",
        top: "92%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        cursor: "pointer",
    };

    // Style the ::after pseudo-element
    const pseudoElementStyle = {
        content: '""',
        position: "absolute",
        top: "110%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "10px",
        height: "10px",
        backgroundColor: "white",
        borderRadius: "50%",
    };


    const [isFullscreen, setIsFullscreen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [isGrabbed, setIsGrabbed] = useState(false);

    useEffect(() => {
        // Make the personal-info-section draggable
        $(".personal-info-section").draggable({
            containment: ".homepage",
            disabled: isFullscreen, // Disable draggable when in fullscreen mode
        });

        // Full screen functionality
        $(".bi-arrows-fullscreen").on("click", function () {
            toggleFullScreen();
        });

        // Minimize functionality
        $(".bi-dash").on("click", function () {
            minimizeSection();
        });

        // Reopen minimized section
        $(".minimized-icon").on("click", function () {
            reopenSection();
        });

        // Close personal-info-section
        $(".bi-x").on("click", function () {
            $(".personal-info-section").hide();
        });

    }, [isFullscreen, isMinimized]); // Update when fullscreen or minimized state changes

    function toggleFullScreen() {
        const personalInfoSection = document.querySelector(".personal-info-section");
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().then(() => {
                setIsFullscreen(true);
                personalInfoSection.style.width = "100vw";
                personalInfoSection.style.height = "100vh";
                personalInfoSection.style.top = "0";
                personalInfoSection.style.left = "0";
                personalInfoSection.style.zIndex = "9999";
            });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            setIsFullscreen(false);
            personalInfoSection.style.width = "auto";
            personalInfoSection.style.height = "auto";
            personalInfoSection.style.zIndex = "auto";
            // Re-enable draggable after exiting fullscreen mode
            $(".personal-info-section").draggable("enable");
        }
    }

    function minimizeSection() {
        $(".personal-info-section").hide();
        setIsMinimized(true);
    }

    function reopenSection() {
        $(".personal-info-section").show();
        setIsMinimized(false);
    }

    function handleSectionClick() {
        setIsGrabbed(true);
    }

    return (
        <>
            <div className="homepage flex object-fill">
                {!isMinimized && (
                    <div className="personal-info-section">
                        <div className="headers-icons">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-x"
                                viewBox="0 0 16 16"
                            >
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                            </svg>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-dash"
                                viewBox="0 0 16 16"
                            >
                                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                            </svg>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrows-fullscreen"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
                                />
                            </svg>
                        </div>
                        <h1 className="flex-auto first-animation">
                            <span className="name-caption">print(</span>
                            <span className="name-value">"Mohit Kumar Raj Badi"</span>
                            <span className="name-caption">);</span>
                        </h1>
                        <span className="work-interest">
                            <h1 className="job-titles second-animation">job_titles = [</h1>
                            <h1 className="job-titles-value third-animation">"Solution Engineering - Associate @ FICO",</h1>
                            <h1 className="job-titles-value fourth-animation">"AI Developer",</h1>
                            <h1 className="job-titles-value fifth-animation">"Flutter Developer",</h1>
                            <h1 className="job-titles-value sixth-animation">"React Developer",</h1>
                            <h1 className="job-titles-value seventh-animation">"Programmer"</h1>
                            <h1 className="job-titles eighth-animation">]</h1>
                        </span>
                    </div>
                )}
                {isMinimized && (
                    <div className="minimized-icon" style={minimizedIconStyle}>
                        {vsCodeIcon}
                        <span style={pseudoElementStyle}></span>
                    </div>
                )}
            </div>
        </>
    );
}

export default Homepage;
